import { useEffect } from 'react'

export default function DapScriptLoader() {
  useEffect(() => {
    if (document.getElementById('_fed_an_ua_tag')) {
      return
    }

    const script = document.createElement('script')
    script.src =
      'https://dap.digitalgov.gov/Universal-Federated-Analytics-Min.js?agency=DHS'
    script.async = true
    script.type = 'text/javascript'
    script.id = '_fed_an_ua_tag'
    document.body.appendChild(script)

    return () => {
      const existingScript = document.getElementById('_fed_an_ua_tag')
      if (existingScript) {
        existingScript.remove()
      }
    }
  }, [])

  return null
}
